/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { HeaderDetectionOptions } from "../../types/HeaderDetectionOptions";
export const DetectHeaderRequest = core.serialization.object({
    options: HeaderDetectionOptions,
    data: core.serialization.list(core.serialization.list(core.serialization.string())),
});
